import { render } from "./LightningProductSearch.vue?vue&type=template&id=49e74851&scoped=true"
import script from "./LightningProductSearch.vue?vue&type=script&lang=js"
export * from "./LightningProductSearch.vue?vue&type=script&lang=js"

import "./LightningProductSearch.vue?vue&type=style&index=0&id=49e74851&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e74851"]])

export default __exports__